<template>
    <b-tabs v-model="activeTab" content-class="management-tab-content" class="management-tab apprentice-tab" @input="updateTabIndex">
        <b-tab :title="$t('management.categories')" title-item-class="categories-tab">
            <design-2021-school-settings-profile-categories-component :categories-in="categories">
            </design-2021-school-settings-profile-categories-component>
        </b-tab>
        <b-tab :title="$t('management.administrators')" title-item-class="management-tab">
            <design-2021-management-profile-management-component :teachers-in="teachersIn">
            </design-2021-management-profile-management-component>
        </b-tab>
        <b-tab :title="$t('management.access')" title-item-class="access-tab">
            <design-2021-school-settings-profile-access-component
                :isadmin-in="isAdmin"
                :teachers-in="teachersIn"
                :school-in="school"
                :las-groups-in="lasGroupsIn"
                :las-main-groups-in="lasMainGroupsIn">
            </design-2021-school-settings-profile-access-component>
        </b-tab>
    </b-tabs>
</template>

<script>
export default {
    name: "design-2021-management-profile-component",
    props: [
        'isAdmin',
        'teachersIn',
        'schoolIn',
        'lasGroupsIn',
        'lasMainGroupsIn'
    ],
    data () {
        return {
            activeTab: 0,
            school: this.schoolIn,
            categories: this.schoolIn.profile_categories,
            storageName: `management-profile-index-${this.$authUser.id}`,
        }
    },

    methods: {
        updateTabIndex(tabIndex) {
            this.activeTab = tabIndex;
            localStorage.setItem(this.storageName, tabIndex);
        },

        showActiveTab(){
            if(localStorage.getItem(this.storageName) !== null) {
                return parseInt(localStorage.getItem(this.storageName));
            }
        },
    },

    created() {
        if(localStorage.getItem(this.storageName)){
            this.activeTab = parseInt(localStorage.getItem(this.storageName));
        }
    }
}
</script>

<style scoped lang="scss">

</style>
